import { useLocalStorage } from '@vueuse/core';

const name = useLocalStorage('eve-log-reporter', '');

export function useReporter() {
  return { name };
}
